import React, { useState, useEffect } from 'react';
import './MemberOnboarding.css';
import { useParams } from "react-router-dom";
import { fetchMemberOnboardingData, onboardMembers, fetchProgramList } from '../../../services/medengage/Service';
import { CustomLoader, ModalBoxButton } from '../../../pages/utils/CommonLibrary';
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';
import BackendDrivenDataTable from '../../cn/components/common/BackendDrivenDataTable';
import { MultiSelect } from "react-multi-select-component";

function MemberOnboarding() {

    const { id } = useParams();
    const navigate = useNavigate();
    const [careUserName, setCareUserName] = useState('');
    const [transferFromCNTotalMembers, setTransferFromCNTotalMembers] = useState("");
    const [careData, setCareData] = useState([]);
    const [checked, setChecked] = useState([]);
    const [dropdownValues, setDropdownValues] = useState({});
    const [reasonSelect, setReasonSelect] = useState('All');
    const [typeSelect, setTypeSelect] = useState('All');
    const [reasonText, setReasonText] = useState('');
    const [selectError, setSelectError] = useState('');
    const [careError, setCareError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalClass, setModalClass] = useState('md');
    const [modalBody, setModalBody] = useState('');
    const [showModalButton, setShowModalButton] = useState(false);
    const [showSubmit, setShowSubmit] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const [showHide, setShowHide] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [showBulkTransferModal, setShowBulkTransferModal] = useState(false);
    const [transferToCNList, setTransferToCNList] = useState("");
    const [allChecked, setAllChecked] = useState(false);

    //Changes related to backend driven data table 
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("createdTime");
    const [sortDirection, setSortDirection] = useState('desc');
    const [download, setDownload] = useState('N');
    const [conditionList, setConditionList] = useState([]);
    const [selectedConditions, setSelectedConditions] = useState([]);
    const [cnList, setCNList] = useState([]);
    const [selectedCN, setSelectedCN] = useState(0);

    useEffect(() => {
        loadUserData();
        fetchConditionsList();
    }, [page, perPage, sortColumn, sortDirection, filterText]);

    useEffect(() => {
        setAllChecked(false);
        setChecked([])
    }, [careData]);
    //=============================================

    const fetchConditionsList = async () => {
        await fetchProgramList()
            .then((response) => {
                setConditionList(
                    response.data.data.conditionList.map((condition) => ({
                        label: condition.conditionName,
                        value: condition.conditionId,
                    }))
                );
            });
    }

    const handleClose = () => {
        setShowModal(false);

        //setLoading(true);
        loadUserData();
        setReloadKey(prevKey => prevKey + 1);
    }

    const getNextWeekRange = () => {
        const end = new Date();
        const start = new Date();
        end.setDate(end.getDate() + 7);
        return [start, end];
    };

    const [dateRange, setDateRange] = useState(getNextWeekRange);
    const [startDate, endDate] = dateRange;
    const [dateStartNew, setDateStartNew] = useState(new Date());

    const [errors, setErrors] = useState({
        conditions: '',
        carenavigator: ''
    });


    useEffect(() => {
        loadUserData();
    }, []);

    useEffect(() => {
        if (checked.length <= 0) {
            setAllChecked(false);
        }

        if (checked.length == careData.length) {
            setAllChecked(true);
        }
    }, [checked]);

    const handleButtonAction = () => {
        navigate('/member-onboarding', { replace: true });
    };

    const loadUserData = async () => {
        try {
            setCareData([]);
            setLoading(true);
            fetchMemberOnboardingData(filterText, page, perPage, sortColumn, sortDirection)
                .then((response) => {
                    if (response.data.code == 200) {
                        setCNList(response.data.data.cnListWithDetails);
                        setCareData(response.data.data.members);
                        setTotalRows(response.data.data.totalRows)
                    }
                }).finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            console.error('Error=', error);
        }
    }

    // function formatDate(dateString) {
    //     const date = new Date(dateString);
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const day = String(date.getDate()).padStart(2, '0');
    //     return `${day}/${month}/${year}`;
    // }

    function formatDateYmd(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleSubmit = async () => {
        try {

            if (selectedConditions.length <= 0) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    conditions: 'Select conditions'
                }));
                return;
            } else if (selectedCN <= 0) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    carenavigator: 'Select CareNavigator'
                }));
                return;
            } else if (checked.length == 0) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    members: 'Select Members'
                }));
                return;
            }

            setShowModalButton(false);
            setShowModal(true);
            setModalTitle('Alert!');
            setModalBody('In Progress, Wait!!!')
            setShowSubmit(false);

            onboardMembers(JSON.stringify(checked), JSON.stringify(selectedConditions), selectedCN)
                .then((response) => {
                    if (response.data.code == 200) {
                        setModalBody(response.data.data.message)
                        setErrors('')
                        setSelectedConditions([]);
                        setSelectedCN(0);
                        setModalTitle('Success');
                        setShowModalButton(true);
                        setShowHide(true);
                        setChecked([]);
                        setPage(1);
                    } else {
                        setModalTitle('Alert');
                        setShowModalButton(false);
                        setShowSubmit(true);
                        setShowHide(false);
                    }
                });

        } catch (error) {
            console.error('Error submitting data', error);
        }
    };

    const handleAllChange = (e) => {
        const { checked } = e.target;
        if (checked) {
            setChecked(careData.map(item => item.userId));
            setAllChecked(true);
        } else {
            setChecked([]);
            setAllChecked(false);
        }
    };

    const handleCheckboxChange = (e, userId) => {
        const { checked } = e.target;

        setChecked(prevChecked =>
            checked
                ? [...prevChecked, userId]
                : prevChecked.filter(id => id !== userId)
        );

    };

    const columns = [
        {
            name: (
                <div>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexCheckAll"
                        onChange={handleAllChange}
                        checked={allChecked}
                    /> All
                </div>
            ),
            cell: row => (
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={`flexCheck${row.userId}`}
                    onChange={(e) => handleCheckboxChange(e, row.userId)}
                    checked={checked.includes(row.userId)}
                />
            ),
            sortable: false,
        },
        {
            name: 'Member ID',
            selector: row => row.membershipNo,
            sortable: true,
        },
        {
            name: 'Main Membership No',
            selector: row => row.mainMembershipNo,
            sortable: true,
        },
        {
            name: 'Member Name',
            selector: row => row.memberName,
            sortable: false,
        },
        {
            name: 'Mobile',
            selector: row => row.mobile,
            sortable: false,
        },
        {
            name: 'Gender',
            selector: row => row.gender,
            sortable: false,
        },
        {
            name: 'Age',
            selector: row => row.age,
            sortable: false,
        },
        {
            name: 'Programs',
            selector: row => row.programs,
            sortable: false,
        },
        {
            name: 'Conditions',
            selector: row => row.conditions,
            sortable: false,
        },
        {
            name: 'Pathways',
            selector: row => row.pathways,
            sortable: false,
        }
    ];

    const handleConditions = (selectedOptions) => {
        //const selectedValues = selectedOptions.map((option) => option.value);
        setSelectedConditions(selectedOptions);
    };
    return (
        <>
            <section className='ContentMemberTransfer'>
                <div className="row align-items-center pb-3 sticky-top-bar">
                    <div className="col-md" style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <h1 className="main-title mb-0 ">Member Onboarding</h1>
                    </div>
                </div>

                <div className='reports-programs mb-3'>
                <div className="row align-items-center">
                    <div className="col-md-auto">
                        <img src="https://storage.googleapis.com/ksabupatest/2025/05/08/r4t06/nhqllubad8.avif" alt="Invited Members icon" style={{ height: "140px" }} className="img-fluid mb-0" />
                    </div>
                    <div className="col-md">
                        <p className="mb-0">Streamlines the management of new members by enabling the assignment of CareNavigators and conditions, ensuring a smooth transition into the care program.</p>
                    </div>
                </div>
            </div>

                <div className="container-fluid">
                    <div className="row align-items-center pb-3">
                        <div className='comntent-MemberTransfer mb-3 p-3'>
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor='reasonFrom' className="col-form-label" style={{ fontSize: "14px" }}>Conditions:</label>
                                            <MultiSelect
                                                className="rmsc-2 form-select-2 select-input-ui-2 select-input-ui-select-2"
                                                options={conditionList}
                                                value={selectedConditions}
                                                onChange={handleConditions}
                                                labelledBy="Select Teams to Utilize Template"
                                                overrideStrings={{
                                                    selectSomeItems: "Choose Conditions",
                                                    search: "Search...",
                                                    noOptions: "Record not matched",
                                                }}
                                            />
                                            {(errors['conditions']) && <div className="text-danger">{errors['conditions']}</div>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-7 mb-3">
                                    <div className="row align-items-center">
                                        <div className="col-4 ps-0">
                                            <label htmlFor='reasonFrom' className="col-form-label" style={{ fontSize: "14px" }}>Care Navigator:</label>
                                            <select value={selectedCN} onChange={e => setSelectedCN(e.target.value)} className='form-select input-field-ui' >
                                                <option value="0">Select</option>
                                                {
                                                    cnList.map((item, index) => {
                                                        return <option value={item.cnID}>{item.cnName}</option>
                                                    })
                                                }
                                            </select>
                                            {(errors['carenavigator']) && <div className="text-danger">{errors['carenavigator']}</div>}
                                        </div>

                                        <div className='col-md d-flex ps-0' style={{ paddingTop: "35px" }}>
                                            <div className="form-group" style={{ width: "100%" }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search by Member ID"
                                                    value={filterText}
                                                    onChange={e => {
                                                        setPage(1);
                                                        setFilterText(e.target.value);
                                                    }}
                                                    className="form-control input-field-ui ps-5"
                                                />
                                                <img src="https://storage.googleapis.com/ksabupatest/2024/09/24/wjm48/fh6lw97sch.png" className="input-icon-seacrh" alt="" />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="table-responsive MemberTransferTable">
                                        <div className="text-danger">{selectError}</div>
                                        <div className="text-danger">{careError}</div>
                                        {

                                            <div>
                                                {
                                                    loading ? <CustomLoader /> :
                                                        <BackendDrivenDataTable
                                                            data={careData}
                                                            loading={loading}
                                                            totalRows={totalRows}
                                                            page={page}
                                                            perPage={perPage}
                                                            sortColumn={sortColumn}
                                                            sortDirection={sortDirection}
                                                            columns={columns}
                                                            fetchTableData={loadUserData}
                                                            setPage={setPage}
                                                            setSortColumn={setSortColumn}
                                                            setSortDirection={setSortDirection}
                                                            setPerPage={setPerPage}
                                                        />
                                                }
                                            </div>
                                        }

                                    </div>
                                </div>
                                {(errors['members']) && <div className="text-danger">{errors['members']}</div>}
                                {(checked.length > 0) && <div className="col-md-12 text-center mb-3">
                                    <button className='btn program-save-btn me-2' onClick={handleSubmit}>Onboard</button>
                                </div>}

                            </div>
                        </div>
                    </div>
                </div>
                {showModal ? <ModalBoxButton handleClose={handleClose} showModaln={showModal} titlen={modalTitle} bodyn={modalBody} type={modalClass} button={handleClose} hideButton={showHide} /> : null}
            </section>

        </>
    );
}

export default MemberOnboarding